<script setup lang="ts">
const store = useStore()

await callOnce(async () => {
  await store.init()
})

const { shopInformation } = storeToRefs(store)

useSchemaOrg([
  defineOrganization({
    '@type': 'Organization',
    name: 'Go-racing',
    telephone: shopInformation.value.shopInformation.phone,
    email: shopInformation.value.shopInformation.contactEmail,
    image: '/logo.svg'
  })
])
</script>

<template>
  <NuxtPwaAssets />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
